import React, { useEffect, useRef, useState } from 'react'

/** Finger / mouse signature pad. Reports whether something was drawn; the image itself is not stored in the demo. */
export default function Signature({ onChange, height }) {
    const ref = useRef(null)
    const drawing = useRef(false)
    const [has, setHas] = useState(false)

    useEffect(() => {
        const c = ref.current
        const ratio = window.devicePixelRatio || 1
        const fit = () => {
            const w = c.clientWidth
            const h = c.clientHeight
            c.width = w * ratio
            c.height = h * ratio
            const ctx = c.getContext('2d')
            ctx.scale(ratio, ratio)
            ctx.lineWidth = 2.6
            ctx.lineCap = 'round'
            ctx.strokeStyle = '#0F172A'
        }
        fit()
    }, [])

    const pos = (e) => {
        const r = ref.current.getBoundingClientRect()
        const t = e.touches && e.touches[0] ? e.touches[0] : e
        return { x: t.clientX - r.left, y: t.clientY - r.top }
    }
    const down = (e) => { e.preventDefault(); drawing.current = true; const p = pos(e); const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(p.x, p.y) }
    const move = (e) => {
        if (!drawing.current) return
        e.preventDefault()
        const p = pos(e)
        const ctx = ref.current.getContext('2d')
        ctx.lineTo(p.x, p.y)
        ctx.stroke()
        if (!has) { setHas(true); onChange(true) }
    }
    const up = () => { drawing.current = false }
    const clear = () => {
        const c = ref.current
        c.getContext('2d').clearRect(0, 0, c.width, c.height)
        setHas(false)
        onChange(false)
    }
    return (
        <div className="fo-sig">
            <canvas ref={ref} style={{ height: height || 160 }} onMouseDown={down} onMouseMove={move} onMouseUp={up} onMouseLeave={up} onTouchStart={down} onTouchMove={move} onTouchEnd={up} aria-label="Signature pad" />
            {!has ? <span className="fo-sig__hint">Customer signs here</span> : null}
            <button type="button" className="fo-sig__clear" onClick={clear} disabled={!has}>Clear</button>
        </div>
    )
}
